if(!customElements.get('variant-selector')){
    class VariantSelector extends HTMLElement { 
        constructor() {
            super();
        }

        connectedCallback(){
            this.initialize();
        }

        initialize(){
            if(this.listenerController) this.listenerController.abort();
            this.listenerController = new AbortController();

            this.type = this.dataset.type;
            this.inputs = this.querySelectorAll('.product-form__input');
            this.section = this.closest('.section-product');
            if(this.section){
                this.sectionType = this.section?.classList.contains('section-product--main')? 'main-product' : 'featured-product';
            }

            if(this.dataset.showOnlySwatchButton === 'true'){
                const swatchButton = true;
                this.initializeButton(swatchButton);
                this.initializeDropdown(swatchButton);
            }else if(this.type === 'dropdown' || this.type == 'swatch-dropdown'){
                this.initializeDropdown();
            }else{
                this.initializeButton();
            }
        }

        initializeButton(swatchButton = false){
            const signal = this.listenerController.signal;
            this.inputs.forEach(item => {
                if(swatchButton && item.dataset.fieldType !== 'button') return;

                const groupRadios = item.querySelectorAll('input[type="radio"]');
                groupRadios.forEach(radio => {
                    radio.addEventListener("change", (e) => {
                        const selectedOption = item.querySelector('input[type="radio"]:checked');
                        const data = {
                            event: e,
                            target: selectedOption,
                            selectedOptionValues: this.selectedOptionValues,
                            source: this.sectionType? this.sectionType : null,
                        }
                        this.updateValue(data);

                        if(!this.section){ // none product page
                            if(this.closest('.section-product-compare-popup')) {
                                const productData = {
                                    event: e,
                                    target: selectedOption,
                                    selectedOptionValues: this.selectedOptionValues,
                                    variantIndex: this.closest('.variant').dataset.productIndex
                                }
                                PubSub.publish(PubSub.events.optionValueSelectionChangeInCompareProduct, {
                                    data: productData
                                });
                            }
                        }
                    }, { signal });

                    const label = item.querySelector(`label[for="${radio.id}"]`);
                    if(label){
                        label.addEventListener("keydown", (e) => {
                            if(e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                radio.checked = true;
                                radio.dispatchEvent(new Event('change', { bubbles: true }));
                            }
                        }, { signal });
                    }
                });
            });
        }

        initializeDropdown(swatchButton = false){
            const signal = this.listenerController.signal;
            this.inputs.forEach(item => {
                if(swatchButton && item.dataset.fieldType !== 'dropdown') return;

                const buttonDropdown = item.querySelector('.input--dropdown-selected-option');
                const dropdown = item.querySelector(".input--dropdown-options");
                const dropdownList = dropdown?.querySelectorAll('li') || [];

                item.addEventListener("focusout", (e) => {
                    this.closeDropdownList(e, buttonDropdown);
                }, { signal });
                buttonDropdown?.addEventListener("click", (e) => {
                    if(buttonDropdown.classList.contains('active')){
                        this.closeDropdownList(e, buttonDropdown);
                    }else{
                        this.openDropdownList(e);
                    }
                }, { signal });
                buttonDropdown?.addEventListener("keydown", event => {
                    if(event.key === 'Enter'){
                        if(buttonDropdown.classList.contains('active')){
                            this.closeDropdownList(event, buttonDropdown);
                        }else{
                            this.openDropdownList(event);
                        }
                    }
                }, { signal });

                dropdownList.forEach((item, index) => {
                    item.addEventListener("click", this.selectDropdownOption.bind(this), { signal });
                    item.addEventListener("keydown", event => {
                        if(event.key === 'Enter') this.selectDropdownOption(event);
                        else if(event.key === 'ArrowDown'){
                            event.preventDefault();

                            if(index < dropdownList.length - 1){
                                dropdownList[index + 1].focus();
                            }
                        }else if(event.key === 'ArrowUp'){
                            event.preventDefault();
                            if(index > 0){
                                dropdownList[index - 1].focus();
                            }
                        }else if(event.key === 'Escape'){
                            buttonDropdown.focus();
                            dropdown.setAttribute('inert', '');
                        }
                    }, { signal });
                });

                document.addEventListener("pointerdown", (e) => {
                    if(!item.contains(e.target)){
                        this.closeDropdownList(e, buttonDropdown);
                    }
                }, { signal });
            });
        }

        openDropdownList(e){
            e.preventDefault();

            const isMobile = () => window.matchMedia('(max-width: 48rem)').matches;
            if(isMobile()){
                const select = e.currentTarget.closest('.product-form__input').querySelector('.input--dropdown');
                if(select){
                    if(select.dataset.showPickerMobile === 'true'){
                        select.addEventListener("change", (event) => {
                            const selectEl = event.target;
                            const selectedOption = selectEl.options[selectEl.selectedIndex];

                            const fieldset = event.currentTarget.closest('.product-form__input');
                            const select = fieldset?.querySelector('select');
                            const buttonDropdownLabel = fieldset?.querySelector('.input--dropdown-selected-option > span');

                            Array.from(select.options).forEach(option => {
                                if(option === selectedOption){
                                    option.setAttribute("selected", 'selected');
                                }else{
                                    option.removeAttribute("selected");
                                }
                            });

                            if(buttonDropdownLabel){
                                buttonDropdownLabel.innerHTML = selectedOption.innerHTML;
                            }

                            const data = {
                                event: event,
                                target: selectedOption,
                                selectedOptionValues: this.selectedOptionValues,
                                productId: this.closest('.product-list__product-info').dataset.productId
                            }

                            PubSub.publish(PubSub.events.optionValueSelectionChangeInBundleProduct, {
                                data: data
                            });
                        }, { signal: this.listenerController.signal });

                        if(select.showPicker){
                            select.showPicker();
                            return;
                        }
                        
                        // fallback for browsers that do not support showPicker()
                        select.focus();
                        select.click();
                        return;
                    }
                }
            }
            
            const currentTarget = e.target;
            if(currentTarget.nodeName !== 'LI' && (currentTarget.closest('li') == null || currentTarget.closest('li').classList.contains('product-list__product-info'))){
                const button = e.currentTarget;
                button.classList.add('active');
                const dropdown = button.closest('.input--dropdown-select').querySelector('.input--dropdown-options');
                
                dropdown.removeAttribute('inert');
            }
        }

        closeDropdownList(e, selectedButton = null){
            const button = selectedButton? selectedButton : e.currentTarget;
            
            const dropdownWrapper = button.closest('.input--dropdown-select');
            button.classList.remove('active');
            setTimeout(() => {
                const active = document.activeElement;
            
                if (!dropdownWrapper.contains(active)) {
                    const dropdown = dropdownWrapper.querySelector('.input--dropdown-options');
                    dropdown.setAttribute('inert', '');
                }
            }, 100);
        }

        selectDropdownOption(e){
            const fieldset = e.currentTarget.closest('.product-form__input');
            const select = fieldset?.querySelector('select');
            const selectedOption = select?.options[select.selectedIndex];
            const button = fieldset?.querySelector('.input--dropdown-selected-option');
            const buttonDropdownLabel = fieldset?.querySelector('.input--dropdown-selected-option > span');
            const newOptionValue = e.currentTarget.dataset.option;
            const newOptionValueHTML = e.currentTarget.querySelector('span').innerHTML;

            select.value = newOptionValue;
            Array.from(select.options).forEach(option => {
                if(option.value === newOptionValue){
                    option.setAttribute("selected", 'selected');
                }else{
                    option.removeAttribute("selected");
                }
            });

            if(buttonDropdownLabel){
                buttonDropdownLabel.innerHTML = newOptionValueHTML;
            }

            this.closeDropdownList(null, button);

            const data = {
                event: e,
                target: selectedOption,
                selectedOptionValues: this.selectedOptionValues,
                source: this.sectionType? this.sectionType : null,
            }
            this.updateValue(data);

            if(!this.section){ // none product page
                if(this.closest('.section-product-compare-popup')) {
                    const productData = {
                        event: e,
                        target: selectedOption,
                        selectedOptionValues: this.selectedOptionValues,
                        variantIndex: this.closest('.variant').dataset.productIndex
                    }
                    PubSub.publish(PubSub.events.optionValueSelectionChangeInCompareProduct, {
                        data: productData
                    });
                }else if(this.closest('.section-bundle-products')) {
                    const productData = {
                        event: e,
                        target: selectedOption,
                        selectedOptionValues: this.selectedOptionValues,
                        productId: this.closest('.product-list__product-info').dataset.productId
                    }

                    PubSub.publish(PubSub.events.optionValueSelectionChangeInBundleProduct, {
                        data: productData
                    });
                }
            }
        }

        updateValue(data = {event: null, target: null, selectedOptionValues: null, source: null}){
            PubSub.publish(PubSub.events.optionValueSelectionChange, {
                data: data
            });
        }     

        get selectedOptionValues() {
            return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
                ({ dataset }) => dataset.optionValueId
            );
        }
    }

    customElements.define('variant-selector', VariantSelector);
}